<template>
  <b-card
    :title="item.projectName||'...'"
  >
    <b-tabs
      v-model="tabIndex"
    >
      <b-tab :title="$t('General')">
        <form-project
          :key="'projectform'"
          ref="project_form"
          v-model="item"
          @submit="success"
        />
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="d-inline-block mr-1"
          @click="generalTabSubmit"
        >
          {{ $t('Save') }}
        </b-button>
      </b-tab>
      <b-tab :title="$t('Data Upload')">

        <form-project-upload
          :key="'projectuploadform'"
          ref="project_upload_form"
          :project-id="$route.params.id"
          @success="success"
          @error="error"
        />

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="d-inline-block mr-1"
          :disabled="inProgress"
          @click="uploadTabSubmit"
        >
          {{ $t('Save') }}
        </b-button>

      </b-tab>
      <b-tab
        :title="$t('Data Update')"
      >
        <form-project-update
          :key="'projectupdateform'"
          ref="project_update_form"
          :project-id="$route.params.id"
          @success="success"
          @error="error"
        />

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="d-inline-block mr-1"
          :disabled="inProgress"
          @click="updateTabSubmit"
        >
          {{ $t('Save') }}
        </b-button>

      </b-tab>
      <b-tab :title="$t('Settings')">

        <form-project-settings
          v-if="item.config"
          :key="'projectsettingsform'"
          ref="project_settings_form"
          v-model="item.config"
          :project-id="this.$route.params.id"
          @submit="success"
        />
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="d-inline-block mr-1"
          @click="settingsTabSubmit"
        >
          {{ $t('Save') }}
        </b-button>

      </b-tab>

      <b-tab :title="$t('Virtual Score Definitions')">
        <table-virtual-score-definitions
          :key="'table-virtual-score-definitions'"
          :project-id="String(this.$route.params.id)"
        />
      </b-tab>

      <b-tab :title="$t('Custom Calculations')">
        <table-custom-calculations
          :key="'table-custom-calculations'"
          :project-id="String(this.$route.params.id)"
        />
      </b-tab>

      <b-tab :title="$t('Report Config')">
        <table-report-configs
          :key="'table-report-configs'"
          :project-id="String(this.$route.params.id)"
        />
      </b-tab>

      <!-- Project Periods -->
      <b-tab
        :title="$t('Project Periods')"
      >
        <table-project-periods
          :key="'table-project-periods'"
          :project-id="String(this.$route.params.id)"
        />
      </b-tab>

      <!-- Project Score Groups -->
      <b-tab
        :title="$t('Project Score Groups')"
      >
        <table-project-score-groups
          :key="'table-project-score-groups'"
          :project-id="String(this.$route.params.id)"
        />
      </b-tab>

    </b-tabs>

  </b-card>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BButton, BCard, BTabs, BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FormProject from '@/layouts/components/forms/FormProject.vue'
import FormProjectSettings from '@/layouts/components/forms/FormProjectSettings.vue'
import FormProjectUpload from '@/layouts/components/forms/FormProjectUpload.vue'
import FormProjectUpdate from '@/layouts/components/forms/FormProjectUpdate.vue'
import TableVirtualScoreDefinitions from '@/layouts/components/TableVirtualScoreDefinitions.vue'
import TableCustomCalculations from '@/layouts/components/TableCustomCalculations.vue'
import TableReportConfigs from '@/layouts/components/TableReportConfigs.vue'
import TableProjectPeriods from '@/layouts/components/TableProjectPeriods.vue'
import TableProjectScoreGroups from '@/layouts/components/TableProjectScoreGroups.vue'

export default {
  components: {
    BCard,
    BButton,
    BTabs,
    BTab,
    FormProject,
    FormProjectSettings,
    FormProjectUpload,
    FormProjectUpdate,
    TableVirtualScoreDefinitions,
    TableCustomCalculations,
    TableReportConfigs,
    TableProjectPeriods,
    TableProjectScoreGroups,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      item: {
        projectCode: null,
        projectName: null,
        status: false,
        configJson: null,
      },
      selectedQuestion: null,
      tabIndex: 0,
      inProgress: false,
    }
  },
  created() {
    if (this.$route.params.id && this.$route.params.id > 0) {
      this.initDetail()
    }
  },
  methods: {
    error(msg) {
      this.inProgress = false
      this.$swal({
        icon: 'error',
        title: 'Error!',
        text: msg,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    },
    success() {
      this.inProgress = false
      this.$swal({
        icon: 'success',
        title: 'Saved!',
        text: 'Saved successfuly.',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    generalTabSubmit() {
      this.$refs.project_form.validationForm()
    },
    settingsTabSubmit() {
      this.$refs.project_settings_form.validationForm()
    },
    uploadTabSubmit() {
      this.inProgress = true
      this.$refs.project_upload_form.validationForm()
    },
    updateTabSubmit() {
      this.inProgress = true
      this.$refs.project_update_form.validationForm()
    },
    initDetail() {
      useJwt.axiosIns.get(`project/${this.$route.params.id}`)
        .then(response => {
          if (response.data) {
            this.item = response.data
            this.item.config = JSON.parse(this.item.configJson)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    questionSelected(val) {
      this.selectedQuestion = val
      this.tabIndex = 3
    },
  },
}
</script>
